module.exports = __webpack_public_path__ + "static/media/default_album_img.b416c0f6.png";